import { icons } from 'assets/icons'
import { Avatar } from 'cwp-components/Utils'
import React, { useState } from 'react'
import { useMediaPlayback } from 'common/hooks/useMediaPlayback'
import { BsPause, BsPlayFill } from 'react-icons/bs'
import ReactPlayer from 'react-player'

const InterviewList = ({ data: interview }: any) => {
  const url = interview?.url
  const { progress, onTimestamps, playerRef, onPlay, isPlaying } =
    useMediaPlayback({ url })

  return (
    <div className='card bg-[#fff] p-[16px]'>
      {/* <ReactPlayer
        className='hidden'
        playing={isPlaying}
        url={interview.url}
        ref={playerRef}
        onProgress={onTimestamps}
      /> */}
      <div className='flex flex-wrap items-center justify-between'>
        <div className='flex items-center flex-wrap justify-between'>
          <Avatar
            picture={interview.publisher.avatar}
            name={interview.publisher.name}
            caption={interview.publish_date}
            className={'md:pr-3 min-w-[214px]'}
          />
          <div className='md:hidden'>
            <img src={icons.Heart} className='h-5 inline' alt='' />
            <span className='text-[14px] font-extralight ml-2'>
              {interview.view_count} plays
            </span>
          </div>
          <div className='flex w-full justify-between items-center md:hidden mt-3 mb-3'>
            <div className='flex items-center gap-3 md:border-r-2 px-3'>
              <p className='text-[16px] font-extralight'>1hr, 24 min</p>
              <div className='w-10 md:w-16 bg-gray-200 rounded-full h-1'>
                <div
                  className={`bg-blue-600 h-1 rounded-full`}
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
            <div className='flex items-center gap-3'>
              <img src={icons.Upload} className='h-6' alt='' />
              <button
                onClick={onPlay}
                className='flex items-center bg-[#F4F4F4] text-[#A0ABBE] rounded-full p-2 hover:bg-[#E4E4E4] transition-colors duration-200 shadow-[0px_0.4px_4px_rgba(0,0,0,0.25)]'
              >
                {!isPlaying ? <BsPlayFill size={16} /> : <BsPause size={16} />}
              </button>
            </div>
          </div>

          <div className='flex md:border-l-2 md:border-y-0 max-sm:w-full border-y-2 mx-0 md:py-0 py-3'>
            {interview.interviewers.map((interviewer) => (
              <>
                <Avatar
                  picture={interviewer.avatar}
                  name={interviewer.name}
                  caption={interviewer.type}
                  tx={10}
                  sx={24}
                  className={'md:pl-3 min-w-[214px]'}
                />
              </>
            ))}
          </div>
        </div>

        <div className='flex items-center'>
          <div className='flex gap-1 md:border-r-2  md:px-2 max-sm:mt-3 text-[12px]'>
            {interview.tags.map((tag, idx) => (
              <div
                className={`badge ${idx % 2 ? 'bg-[#EBF3FF]' : 'bg-[#D2F6FF]'}`}
                key={`interview-tags-${idx}`}
              >
                {tag}
              </div>
            ))}
          </div>
          <div className='flex items-center gap-3 border-r-2 px-3 max-sm:hidden'>
            <p className='text-[16px] font-extralight'>1hr, 24 min</p>
            <div className='md:w-20 bg-gray-200 rounded-full h-1'>
              <div
                className={`bg-blue-600 h-1 rounded-full w-[${progress}%]`}
              ></div>
            </div>
          </div>
          <div className='flex items-center gap-3 px-3 max-sm:hidden'>
            <div>
              <img src={icons.Heart} className='h-5 inline' alt='' />
              <span className='text-[14px] font-extralight ml-2'>
                {interview.view_count} plays
              </span>
            </div>
            <img src={icons.Upload} className='h-6' alt='' />
            <button
              onClick={onPlay}
              className='flex items-center bg-[#F4F4F4] text-[#A0ABBE] rounded-full p-2 hover:bg-[#E4E4E4] transition-colors duration-200 shadow-[0px_0.4px_4px_rgba(0,0,0,0.25)]'
            >
              {!isPlaying ? <BsPlayFill size={16} /> : <BsPause size={16} />}
            </button>
          </div>
        </div>
      </div>
      <div className='flex flex-col mt-10'>
        <h1 className='font-normal md:text-[16px] text-[14px]'>
          {interview.title}
        </h1>
        <p className='md:text-[16px] text-[14px] text-text-muted font-normal mt-2 mb-3'>
          {interview.description}
        </p>
        <div className='flex items-center justify-end font-normal gap-3 text-[16px]'>
          <img src={icons.Download} alt='' /> Download transcript
        </div>
      </div>
    </div>
  )
}

export default InterviewList
